import { render } from "./RequestAccess.vue?vue&type=template&id=6d11d74c&scoped=true"
import script from "./RequestAccess.vue?vue&type=script&lang=js"
export * from "./RequestAccess.vue?vue&type=script&lang=js"

import "./RequestAccess.vue?vue&type=style&index=0&id=6d11d74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d11d74c"]])

export default __exports__